import React, { Fragment } from 'react';
import { Col } from 'reactstrap';

const   PackageDetail = ({ details, features_list }) => {
  // Safe fallbacks for data properties
  const name = details?.name || 'Package';
  const description = details?.description || 'For small operators getting started';
  const currency = features_list?.currency || details?.currency || 'USD';
  const price = details?.price || '0.00';
  const duration = details?.duration || 'Monthly';
  const setupCost = features_list?.setup_cost || details?.setup_cost || '0.00';
  const minConnection = details?.max_connection || '0';
  const extraPrice = details?.price || '0.00';

  return (
    <Col xl="6" lg="6" md="12" sm="12" className="pe-lg-4 mb-4 mb-lg-0">
        <h4 className="payment-info-title">Selected Plan</h4>
      <div className="plan-details-card">
        <h3 className="plan-name">{name}</h3>
        <p className="plan-desc">{description}</p>
        
        <div className="plan-price-box">
          <span className="plan-price">{currency} {price}</span>
          <span className="plan-price-duration">/{duration}</span>
        </div>
        
        {/* <div className="plan-setup-cost">
          Setup Cost <span className="setup-cost-amount">{currency} {setupCost}</span>
        </div>
         */}
        <div className="plan-connections-pill">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
          </svg>
          <span>Max {minConnection} connections</span>
        </div>
        
        {(() => {
          const sections = [];
          let currentSection = { title: null, items: [] };

          if (details?.features) {
            details.features.split('\n').forEach(feature => {
              if (!feature.trim()) return;
              if (feature.startsWith('**')) {
                if (currentSection.items.length > 0 || currentSection.title !== null) {
                  sections.push(currentSection);
                }
                currentSection = { title: feature.replace(/\*\*/g, '').trim(), items: [] };
              } else {
                currentSection.items.push(feature);
              }
            });
            if (currentSection.items.length > 0 || currentSection.title !== null) {
              sections.push(currentSection);
            }
          }

          // If no features parsed, render empty state or defaults
          if (sections.length === 0) {
            return null;
          }

          return sections.map((section, sIndex) => (
            <React.Fragment key={`section-${sIndex}`}>
              <div className="section-header">
                {sIndex === 0 ? "WHAT'S INCLUDED" : section.title?.toUpperCase()}
              </div>
              <ul className="features-list-custom">
                {section.items.map((feature, fIndex) => (
                  <li key={`feature-${sIndex}-${fIndex}`}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <span>{feature}</span>
                  </li>
                ))}
                {sIndex === 0 && (
                  <li>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <span>Duration: {duration}</span>
                  </li>
                )}
              </ul>
            </React.Fragment>
          ));
        })()}
      </div>
    </Col>
  );
};

export default PackageDetail;
